export default __webpack_public_path__ + "atomic/_patterns/03-organisms/ct-blog/_ct-blog.twig";